/**
 * Safe localStorage utilities that handle SSR and browser compatibility
 */

/**
 * Safely retrieves a value from localStorage
 * @param key - The storage key
 * @returns The stored value or null if not available
 */
export const getFromLocalStorage = (key: string): string | null => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      return localStorage.getItem(key)
    }
    return null
  } catch {
    return null
  }
}

/**
 * Safely stores a value in localStorage
 * @param key - The storage key
 * @param value - The value to store
 */
export const setToLocalStorage = (key: string, value: string): void => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem(key, value)
    }
  } catch {
    // Silently fail if localStorage is not available
  }
}

/**
 * Safely removes a value from localStorage
 * @param key - The storage key to remove
 */
export const removeFromLocalStorage = (key: string): void => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.removeItem(key)
    }
  } catch {
    // Silently fail if localStorage is not available
  }
}

/**
 * Safely clears all localStorage
 */
export const clearLocalStorage = (): void => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.clear()
    }
  } catch {
    // Silently fail if localStorage is not available
  }
}
